import { IRouterMiddleware } from '../middleware.interface';
import { ClearOauthState } from './ClearOauthState';
import { HandleAuthCallback } from './HandleAuthCallback';
import { HandleOauthCallback } from './HandleOauthCallback';
import { HandleShouldHideRedirect } from './HandleShouldHideRedirect';
import { LoadBusinessList } from './LoadBusinessList';
import { LoadProvidersList } from './LoadProvidersList';
import { HandleInviteRedirect } from './InviteRedirect';
import { HandleAccessGuard } from './AccessGuard';
import { HandleSigninRedirectRestrictedPages } from './HandleSigninRedirectRestrictedPages';
import { HandleSellCoinsRedirect } from './SellCoinsRedirect';
import { PublicRoutesRedirect } from './PublicRoutesRedirect';

export const middlewares: IRouterMiddleware[] = [
  new PublicRoutesRedirect(),
  new LoadBusinessList(),
  new LoadProvidersList(),
  new HandleOauthCallback(),
  new HandleSellCoinsRedirect(),
  new ClearOauthState(),
  new HandleAuthCallback(),
  new HandleShouldHideRedirect(),
  new HandleInviteRedirect(),
  new HandleSigninRedirectRestrictedPages(),
  new HandleAccessGuard()
];
